module.exports = __webpack_public_path__ + "static/media/sidebar_grading_blue.06c14a12.svg";